import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { LogoutReason } from '../../services/auth/logout.service';

@Injectable({ providedIn: 'root' })
export class ModernFrameSessionService {
  readonly #logout = new Subject<LogoutReason>();
  readonly #sessionReplaced = new Subject<void>();
  readonly logout$: Observable<LogoutReason> = this.#logout.asObservable();
  readonly sessionReplaced$: Observable<void> = this.#sessionReplaced.asObservable();

  notifyLogout(reason: LogoutReason): void {
    this.#logout.next(reason);
  }

  notifySessionReplaced(): void {
    this.#sessionReplaced.next();
  }
}
